export const routes = [{
  path: '/pergunta',
  component: () =>
    import(/* webpackChunkName: "ur" */ './components/List'),
  name: 'pergunta.list',
  meta: {
    requiresAuth: true
  }
}]
